import {
  APP_3in1,
  APP_M1,
  APP_SRC,
  APP_URL_INDENTIFIER,
  WEB_VIEW_MODE,
  WEB_VIEW_MODE_ON,
} from "../constants/sso.constants";
import { getCookie, getParams, isBrowser } from "./common-utils";

export const isOpenInApp = (): boolean => {
  if (typeof window !== "undefined") {
    return (
      window.location.href.includes(APP_URL_INDENTIFIER) ||
      getParams(APP_SRC) === APP_3in1 ||
      getParams(APP_SRC) === APP_M1 ||
      getCookie(WEB_VIEW_MODE) === WEB_VIEW_MODE_ON
    )
  }
  else {
    const headersList = require("next/headers").headers();
    return headersList.get("x-open-in-app") === "true";
  }
};

export const stringToBoolean = (value: string): boolean => {
  return value?.toLowerCase() === "true";
};
